const middleware = {}

middleware['generateXml'] = require('..\\src\\middleware\\generateXml.js')
middleware['generateXml'] = middleware['generateXml'].default || middleware['generateXml']

middleware['iceRouting'] = require('..\\src\\middleware\\iceRouting.js')
middleware['iceRouting'] = middleware['iceRouting'].default || middleware['iceRouting']

middleware['isMembership'] = require('..\\src\\middleware\\isMembership.js')
middleware['isMembership'] = middleware['isMembership'].default || middleware['isMembership']

export default middleware
